import Vue from 'vue';
import Vuex from 'vuex';
import axios from 'axios';
import ErrorHandler from '@/helpers/AuthError';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    authToken: '',
    user: null,
    defaultAvatars: [],
    leagues: [],
    players: [],
    teams: [],
    simulators: [],
  },
  mutations: {
    setAuthToken(state, payload) {
      state.authToken = payload;
    },
    setUser(state, payload) {
      state.user = payload;
    },
    setDefaultAvatars(state, payload) {
      state.defaultAvatars = payload;
    },
    setLeagues(state, payload) {
      state.leagues = payload;
    },
    setPlayers(state, payload) {
      state.players = payload;
    },
    setTeams(state, payload) {
      state.teams = payload;
    },
    setSimulators(state, payload) {
      state.simulators = payload;
    },
  },
  actions: {
    getDefaultAvatars(context) {
      return axios.get('/avatars', {
        headers: {
          Authorization: `Bearer ${context.state.authToken}`,
        },
      })
        .then((response) => {
          context.commit('setDefaultAvatars', response.data);
        });
    },
    getSimulators(context) {
      return axios.get('/simulators', {
        headers: {
          Authorization: `Bearer ${context.state.authToken}`,
        },
        params: { _limit: -1 },
      })
        .then((response) => {
          context.commit('setSimulators', response.data);
        });
    },
    getLeagues(context) {
      return axios
        .get('/leagues', {
          headers: {
            Authorization: `Bearer ${context.state.authToken}`,
          },
          params: { _limit: -1 },
        })
        .then((response) => {
          context.commit('setLeagues', response.data);
        })
        .catch((error) => {
          ErrorHandler.handleError(error);
        });
    },
    getPlayers(context) {
      return axios
        .get('/users', {
          headers: {
            Authorization: `Bearer ${context.state.authToken}`,
          },
          params: { _limit: -1 },
        })
        .then((response) => {
          context.commit('setPlayers', response.data);
        })
        .catch((error) => {
          ErrorHandler.handleError(error);
        });
    },
    getTeams(context) {
      return axios
        .get('/teams', {
          headers: {
            Authorization: `Bearer ${context.state.authToken}`,
          },
          params: { _limit: -1 },
        })
        .then((response) => {
          context.commit('setTeams', response.data);
        })
        .catch((error) => {
          ErrorHandler.handleError(error);
        });
    },
  },
  getters: {
    isLoggedIn(state) {
      return state.authToken !== '' && state.user !== '';
    },
  },
});
